<script lang="ts" setup>
import { FontAwesomeIcon } from '@shared/plugin/icons';
import { useQuery } from '@tanstack/vue-query';
import { berichtenQueries } from '@services/asp-c/queries/Berichten';
import { computed } from 'vue';
import { useAantalBerichten } from '../../composables/aantalBerichten';

const { aantal } = useAantalBerichten();

const { data } = useQuery({
  ...berichtenQueries.get,
  select: (r) => r.data,
  staleTime: 60 * 1000,
});

const showIndicator = computed(() => aantal.value < (data.value?.length ?? 0));
</script>

<template>
  <div class="flex cursor-pointer items-center px-4 text-primary-900 no-underline lg:px-6">
    <a
      :title="showIndicator ? `Er staan nieuwe berichten klaar` : `Berichten`"
      href="/app/menu-app/berichten"
      class="relative flex cursor-pointer items-center border-none bg-transparent text-sm text-inherit outline-none"
      type="button"
    >
      <FontAwesomeIcon size="lg" icon="far fa-bell" />
      <span
        v-if="showIndicator"
        class="absolute -right-1 -top-1 size-2 rounded-full bg-red-500"
      ></span>
    </a>
  </div>
</template>
